import { Form, Grid } from 'semantic-ui-react';
import styled from 'styled-components'

export const StyledHeader = styled.div`
 margin-bottom: 15px;
 display: flex;
 align-items: center;
 .header {
    font-size: 16px !important;
    font-weight: bold;
    margin-right: 10px;
 }
`
export const StyledErrorLabel = styled.div`
white-space: normal;
background: #fff !important;
border: 1px solid #e0b4b4 !important;
color: #9f3a38 !important;
`
export const DrawerFooter = styled(Form.Field)`
margin: 3rem 0 !important;
display: flex;
gap: 10px;
justify-content: flex-end;
`;

export const CellWrapper = styled.div`
font-weight: bold !important;
`
export const ColumnLabels = styled(Grid.Column)`
width: 40% !important;
`